import {
  OtoButtons,
  TableCellProps,
  SimpleTableWithSorting,
  generateColumn,
  getRTOriginal,
} from 'app/components/common';
import React, { useMemo } from 'react';
import { TDeliveryPricing } from 'types';
import i18next from 'i18next';

export type DeliveriesPricingsListProps = {
  deliveriesPricings: TDeliveryPricing[];
  isLoading: (deliveryPricing: TDeliveryPricing) => boolean;
  onRemove?: (deliveryPricing: TDeliveryPricing) => void;
};

const DeliveriesPricingsList: React.FC<DeliveriesPricingsListProps> = ({
  deliveriesPricings,
  isLoading,
  onRemove,
}) => {
  const columns = useMemo(() => {
    return [
      generateColumn('distance_from', {
        customHeader: i18next.t('deliveries-pricings-list.distance-from'),
      }),
      generateColumn('distance_to', {
        customHeader: i18next.t('deliveries-pricings-list.distance-to'),
      }),
      generateColumn('price', {
        customHeader: i18next.t('deliveries-pricings-list.price'),
      }),
      ...(onRemove
        ? [
            generateColumn('id', {
              customHeader: i18next.t('deliveries-pricings-list.actions'),
              customCellFormatter: (
                props: TableCellProps<TDeliveryPricing>
              ) => {
                const deliveryPricing = getRTOriginal<TDeliveryPricing>(props);
                return (
                  <OtoButtons.DeleteButton
                    loading={isLoading(deliveryPricing)}
                    onClick={() => onRemove(deliveryPricing)}
                  />
                );
              },
            }),
          ]
        : []),
    ];
  }, [isLoading, onRemove]);
  return <SimpleTableWithSorting columns={columns} data={deliveriesPricings} />;
};

export default DeliveriesPricingsList;
